import { useEffect, useState } from "react";
import Api from "../api/api";
import Loader from "../shared/loader";
import Pagination from "../shared/pagination";
import arrayUtilities from "../../utilities/arrayUtilities";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import { toDateTimeString } from "../../utilities/dateUtilities";
import stringHelpers from "../../utilities/stringHelpers";
import { Modal, Button } from "react-bootstrap";
import api from "../api/api";
import { saveAs } from 'file-saver';
import { ErrorModal } from "../../utilities/errorModal";
import { SearchBarWithDebounce } from "../shared/searchBarWithDebounce";
import { FiltersModalTrigger } from "../shared/filtersModalTrigger";
import { AppliedFilterPill, renderTagFilterItemLabel } from "../shared/appliedFilterPill";
import appliedFiltersUtilities from "../../utilities/appliedFiltersUtilities";
import { LettersFiltersModal } from "./filters-modals/LettersFiltersModal";
import { LettersScheduleModal } from "../reports/schedule-modals/lettersScheduleModal";

export default function LettersRawData(props) {
    const [lettersData, setLettersData] = useState(null);
    const [modalLetter, setModalLetter] = useState(null);
    const [lettersSearch, setLettersSearch] = useState("");
    const [fromDate, setFromDate] = useState(null);
    const [toDate, setToDate] = useState(null);
    const [datePreset, setDatePreset] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [pageNumber, setPageNumber] = useState(0);
    const [letterTemplates, setLetterTemplates] = useState([])
    const [letterTemplateId, setLetterTemplateId] = useState(null)
    const [downloadCertificateId, setDownloadCertificateId] = useState(null)
    const [downloadError, setDownloadError] = useState(null)
    const [status, setStatus] = useState("")
    const [selectedTags, setSelectedTags] = useState([])
    const [showFiltersModal, setShowFiltersModal] = useState(false);
    const [showFilterPills, setShowFilterPills] = useState(false);
    const [appliedFilters, setAppliedFilters] = useState(null);

    const [showScheduleExportModal, setShowScheduleExportModal] = useState(false);

    const scheduleDateParameters = datePreset !== null
        ? { reportDatePreset: datePreset }
        : { from: fromDate, to: toDate }

    const scheduleInitialParameters = {
        ...scheduleDateParameters,
        letterTemplateId: letterTemplateId,
        letterStatus: status,
        tagIds: selectedTags,
    }

    const closeScheduleExportModal = () => setShowScheduleExportModal(false)

    const getLetterTemplates = () => {
        Api.getLetterTemplates(
            (data) => {
                setLetterTemplates(data)
            },
            (error) => {
                console.log(error)
            },
            props.organisationId,
            props.token
        )
    };
    const getLettersData = (searchQuery, from, to, pageNumber, templateId, status, tagIds) => {
        setIsLoading(true);
        Api.getLettersRawData(
            data => {
                setLettersData(data);
                setIsLoading(false);
            },
            () => {
                setLettersData(null);
                setIsLoading(false);
            },
            searchQuery,
            from, to, pageNumber, templateId, !stringHelpers.isNullOrEmpty(status) ? status : null, tagIds, props.organisationId, props.token
        )
    }

    const changepageNumber = (num) => {
        getLettersData(lettersSearch, fromDate, toDate, num, letterTemplateId, status, selectedTags)
        setPageNumber(num);
    };

    useEffect(() => {
        getLettersData("", null, null, 0, null, null, selectedTags)
        getLetterTemplates()
    }, [])

    const clearFilters = () => {
        setFromDate(null);
        setToDate(null);
        setDatePreset(null);
        setLetterTemplateId(null);
        setStatus("");
        setSelectedTags([]);
        setAppliedFilters(null);
        setShowFilterPills(false);
        setPageNumber(0);
        getLettersData(lettersSearch, null, null, 0, null, "", []);
    }

    const clearFilterByLabel = (label) => {
        switch (label) {
            case "Letter Template":
                setLetterTemplateId(null)
                getLettersData(lettersSearch, fromDate, toDate, 0, null, status, selectedTags)
                break
            case "Status":
                setStatus("")
                getLettersData(lettersSearch, fromDate, toDate, 0, letterTemplateId, "", selectedTags)
                break
            case "From":
                setFromDate(null)
                getLettersData(lettersSearch, null, toDate, 0, letterTemplateId, status, selectedTags)
                break
            case "To":
                setToDate(null)
                getLettersData(lettersSearch, fromDate, null, 0, letterTemplateId, status, selectedTags)
                break
            case "Date Range":
                setFromDate(null)
                setToDate(null)
                setDatePreset(null)
                getLettersData(lettersSearch, null, null, 0, letterTemplateId, status, selectedTags)
                break
            case "Tags":
                setSelectedTags([])
                getLettersData(lettersSearch, fromDate, toDate, 0, letterTemplateId, status, [])
                break
            default:
                break
        }
        setPageNumber(0)
    }

    const handleFilterPillClose = closedLabel => {
        clearFilterByLabel(closedLabel)
        setAppliedFilters(prevState => {
            const updatedFilters = { ...prevState }
            if (closedLabel === "From" || closedLabel === "To" || closedLabel === "Date Range") {
                updatedFilters.From = null
                updatedFilters.To = null
                updatedFilters["Date Range"] = null
            } else {
                updatedFilters[closedLabel] = null
            }
            return appliedFiltersUtilities.hasRemainingFilters(updatedFilters) ? updatedFilters : null
        })
    }

    const handleFilterPillItemRemove = (label, remainingIds) => {
        setAppliedFilters(prevState => appliedFiltersUtilities.keepMultiSelectionItems(prevState, label, remainingIds))
        removeMultiSelectFilterItemByLabel(label, remainingIds)
    }

    const removeMultiSelectFilterItemByLabel = (label, remainingIds) => {
        switch (label) {
            case "Tags":
                setSelectedTags(remainingIds)
                getLettersData(lettersSearch, fromDate, toDate, 0, letterTemplateId, status, remainingIds)
                break
            default:
                break
        }
        setPageNumber(0)
    }
    return (
        <div className="container-fluid">
            <div className="row">
                <div className="col-12">
                    <div className="card mb-3">
                        <div className="card-header">
                            <div className="d-flex align-items-center justify-content-between">
                                <div className="d-flex align-items-center">
                                    <h5 className="mb-0">Letters</h5>
                                </div>
                                <div className="d-flex align-items-center">
                                    <div className='mr-2'>
                                        <SearchBarWithDebounce onSearchQueryChange={ query => { setLettersSearch(query); setPageNumber(0); getLettersData(query, fromDate, toDate, 0, letterTemplateId, status, selectedTags) } } />
                                    </div>
                                    <div className='mr-2'>
                                        <FiltersModalTrigger onClick={ () => setShowFiltersModal(true) } />
                                    </div>
                                    <button
                                        className="btn btn-primary btn-sm mr-1 ml-1 nowrap"
                                        onClick={ () => getLettersData(lettersSearch, fromDate, toDate, pageNumber, letterTemplateId, status, selectedTags) }>
                                        <i className="fas fa-redo"></i> Refresh
                                    </button>
                                    <button
                                        className="btn btn-secondary btn-sm mr-1 ml-1 nowrap"
                                        onClick={ () => setShowScheduleExportModal(true) }>
                                        <i className="far fa-clock"></i> Schedule Report
                                    </button>
                                </div>
                            </div>
                        </div>
                        {
                            showFilterPills && appliedFilters &&
                            <div className="px-3 py-2 border-top d-flex align-items-center flex-wrap">
                                {
                                    Object.entries(appliedFilters).map(
                                        ([label, value]) => <AppliedFilterPill
                                            key={ label }
                                            label={ label }
                                            value={ value }
                                            renderItemLabel={ renderTagFilterItemLabel }
                                            onTextClick={ () => setShowFiltersModal(true) }
                                            onCloseClick={ handleFilterPillClose }
                                            onRemoveItem={ handleFilterPillItemRemove }
                                        />
                                    )
                                }
                                {appliedFilters && Object.keys(appliedFilters).length > 0 && <button type="button" className="btn btn-none p-0 m-0 fs--1 nowrap" onClick={() => clearFilters()}>Clear all filters</button>}
                            </div>
                        }
                        { isLoading
                            ? <Loader />
                            : <div className="card-body bg-white border-top details-container p-0 overflow-auto">
                                <table className="table table-sm mb-0 table-striped table-dashboard fs--1 data-table border-bottom border-200 no-footer letters-raw-data-table">
                                    <thead className="bg-200 text-900">
                                        <tr>
                                            <th className="reference-number-column">Reference Number</th>
                                            <th className="date-column">Date</th>
                                            <th className="attachment-column">Attachment</th>
                                            <th className="page-count-column">Page Count</th>
                                            <th>Status</th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        {
                                            lettersData && !arrayUtilities.isNullOrEmpty(lettersData.items) &&
                                            lettersData.items.map(
                                                letter => <tr key={ letter.id } className={ !stringHelpers.isNullOrEmpty(letter.iMailErrorDetail) ? "table-danger" : "" }>
                                                    <td className="reference-number-column">
                                                        <Link to={ `/organisation/${ props.organisationId }/breach/${ letter.breachId }` }>
                                                            <h6 className="mb-0 text-ellipsis">{ letter.breachReferenceNumber }</h6>
                                                        </Link>
                                                    </td>
                                                    <td>{ toDateTimeString(letter.date) }</td>
                                                    <td className="attachment-column">
                                                        <a href={ `${ letter.fileUrl }&ts=${ Date.now() }` } target="_blank"><h6 className="m-0 text-ellipsis">{ letter.fileName }</h6></a>
                                                    </td>
                                                    <td>{ letter.pageCount }</td>
                                                    <td className="note-cell">
                                                        <div className="d-flex align-items-center justify-content-between overflow-hidden pr-2">
                                                            <p className="m-0 text-ellipsis">
                                                                {
                                                                    !stringHelpers.isNullOrEmpty(letter.iMailErrorDetail)
                                                                        ? <>Error - { letter.iMailErrorDetail }</>
                                                                        : <>{ letter.iMailStatus }</>
                                                                }
                                                            </p>
                                                            <div className="file-card">
                                                                {
                                                                    letter.iMailStatus?.toLowerCase() === "printed"
                                                                    && <button
                                                                        disabled={ downloadCertificateId === letter.id }
                                                                        className='btn btn-none m-0 p-0 mr-2' type='button'
                                                                        onClick={ () => {
                                                                            setDownloadError(null)
                                                                            setDownloadCertificateId(letter.id)
                                                                            api.downloadPostageCertificate(
                                                                                (data, filename) => {
                                                                                    if (data.isError) {
                                                                                        setDownloadError(data.errorMessage)
                                                                                    }
                                                                                    else {
                                                                                        saveAs(data, filename)
                                                                                        setDownloadError(null)
                                                                                    }
                                                                                    setDownloadCertificateId(null)
                                                                                },
                                                                                error => {
                                                                                    setDownloadError(error.errorMessage)
                                                                                    setDownloadCertificateId(null)
                                                                                    console.log(error)
                                                                                },
                                                                                letter.id, props.organisationId, props.token
                                                                            )
                                                                        } }
                                                                    >
                                                                        {
                                                                            downloadCertificateId === letter.id
                                                                                ? <div className='tiny-loader'>
                                                                                    <Loader />
                                                                                </div>
                                                                                : <i className="fas fa-award"></i>
                                                                        }
                                                                    </button>
                                                                }
                                                            </div>
                                                            <button onClick={ () => setModalLetter(letter) } className="btn btn-none p-0 m-0" type="button">
                                                                <i className="fas fa-eye"></i>
                                                            </button>                                                   
                                                        </div>
                                                    </td>
                                                </tr>
                                            )
                                        }
                                    </tbody>
                                </table>
                            </div>
                        }
                        <div className="d-flex justify-content-center row align-items-center pt-2">
                            <div className="col-auto align-items-center">
                                <Pagination totalResults={lettersData?.totalCount} currentPage={pageNumber} changePageNumber={changepageNumber} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {
                modalLetter &&
                <Modal size='lg' show onHide={ () => setModalLetter(null) } centered>
                    <Modal.Header>
                        <Modal.Title>Letter</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div>
                            <div className="row mb-3">
                                <div className="col-4">
                                    <p className="font-weight-semi-bold m-0">Reference Number</p>
                                </div>
                                <div className="col-8 d-flex align-items-center">
                                    <Link to={ `/organisation/${ props.organisationId }/breach/${ modalLetter.breachId }` }>
                                        <h6 className="m-0">{ modalLetter.breachReferenceNumber }</h6>
                                    </Link>
                                </div>
                            </div>
                            <div className="row mb-3">
                                <div className="col-4">
                                    <p className="font-weight-semi-bold m-0">Date</p>
                                </div>
                                <div className="col-8">
                                    <p className="m-0">{ toDateTimeString(modalLetter.date) }</p>
                                </div>
                            </div>
                            <div className="row mb-3">
                                <div className="col-4">
                                    <p className="font-weight-semi-bold m-0">Attachment</p>
                                </div>
                                <div className="col-8 d-flex align-items-center">
                                    <a href={ `${ modalLetter.fileUrl }&ts=${ Date.now() }` } target="_blank"><h6 className="m-0">{ modalLetter.fileName }</h6></a>
                                </div>
                            </div>
                            <div className="row mb-3">
                                <div className="col-4">
                                    <p className="font-weight-semi-bold m-0">Page Count</p>
                                </div>
                                <div className="col-8">
                                    <p className="m-0">{ modalLetter.pageCount }</p>
                                </div>
                            </div>
                            <div className="row mb-3">
                                <div className="col-4">
                                    <p className="font-weight-semi-bold m-0">Status</p>
                                </div>
                                <div className="col-8">
                                    {
                                        !stringHelpers.isNullOrEmpty(modalLetter.iMailErrorDetail)
                                            ? <p className="m-0" style={ { wordBreak: "break-word" } }>Error - { modalLetter.iMailErrorDetail }</p>
                                            : <p className="m-0">{ modalLetter.iMailStatus }</p>
                                    }
                                </div>
                            </div>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button size="sm" variant='secondary' onClick={ () => setModalLetter(null) }>Close</Button>
                    </Modal.Footer>
                </Modal>
            }
            {
                !stringHelpers.isNullOrEmpty(downloadError) &&
                <ErrorModal message={downloadError} onHide={() => {
                    setDownloadCertificateId(null)
                    setDownloadError(null)
                }} />
            }
            {
                showFiltersModal &&
                <LettersFiltersModal
                    showModal={showFiltersModal}
                    handleClose={() => setShowFiltersModal(false)}
                    handleConfirm={(draftFilters) => {
                        setFromDate(draftFilters.fromDate)
                        setToDate(draftFilters.toDate)
                        setDatePreset(draftFilters.datePreset)
                        setLetterTemplateId(draftFilters.letterTemplateId)
                        setStatus(draftFilters.status)
                        setSelectedTags(draftFilters.selectedTags)
                        setAppliedFilters(draftFilters.appliedFilters)
                        setShowFilterPills(true)
                        setShowFiltersModal(false)
                        setPageNumber(0)
                        getLettersData(lettersSearch, draftFilters.fromDate, draftFilters.toDate, 0, draftFilters.letterTemplateId, draftFilters.status, draftFilters.selectedTags)
                    }}
                    initialFromDate={fromDate}
                    initialToDate={toDate}
                    initialDatePreset={datePreset}
                    initialLetterTemplateId={letterTemplateId}
                    initialStatus={status}
                    initialSelectedTags={selectedTags}
                    initialAppliedFilters={appliedFilters}
                    letterTemplates={letterTemplates}
                    tags={props.tags || []}
                    key="letters-raw-data-filters-modal"
                />
            }
            {
                showScheduleExportModal &&
                <LettersScheduleModal
                    tags={ props.tags || [] }
                    organisationId={ props.organisationId }
                    token={ props.token }
                    initialParameters={ scheduleInitialParameters }
                    initialLetterTemplates={ letterTemplates }
                    onCancel={ closeScheduleExportModal }
                    onSaved={ closeScheduleExportModal }
                />
            }
        </div>
    )
}